import { isSandbox } from "./isSandbox";

interface firebaseConfiguration {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export function GetMapAPIKey(): string {
  return "AIzaSyCK07meCLb96wPd0jLIciUSNG5o56YbiSI";
}

export function GetFirebaseConfiguration(): firebaseConfiguration {
  if (isSandbox) {
    return {
      apiKey: "AIzaSyAO7zihpU8vsgn0-tmvR50oyCg53QnzC_o",
      authDomain: "magical-park-sandbox.firebaseapp.com",
      projectId: "magical-park-sandbox",
      storageBucket: "magical-park-sandbox.appspot.com",
      messagingSenderId: "986457648595",
      appId: "1:986457648595:web:f9b633028fdc1026b7d326",
      databaseURL: "https://magical-park-sandbox-default-rtdb.firebaseio.com/",
      measurementId: "", // No measurement for sandbox
    };
  }

  return {
    apiKey: "AIzaSyCK07meCLb96wPd0jLIciUSNG5o56YbiSI",
    authDomain: "magical-parks.firebaseapp.com",
    databaseURL: "https://magical-parks.firebaseio.com",
    projectId: "magical-parks",
    storageBucket: "magical-parks.appspot.com",
    messagingSenderId: "751424146207",
    appId: "1:751424146207:web:81f0cf22fe8509aa813e2a",
    measurementId: "G-PM7QGC82YR",
  };
}

export function yyyymmddToDate(dateStr: string) {
  const parts = dateStr.split("-");
  return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2]));
}



export function GetSettingsURL(): string {
  if (isSandbox) {
    return "https://magical-park-sandbox-default-rtdb.firebaseio.com/Settings.json";
  }
  return "https://magical-parks.firebaseio.com/Settings.json";
}

function getBaseURL(): string {
  if (isSandbox) {
    return "https://us-central1-magical-park-sandbox.cloudfunctions.net/API/";
  }
  return "https://us-central1-magical-parks.cloudfunctions.net/API/";
}

export function GetParksCloseToAddressURL(address: string, lat: number, lng: number): string {
  return getBaseURL() + "Park/CloseTo/" + address + "/" + lat + "/" + lng;
}

export function GetParksCloseToLocationURL(lat: number, lng: number): string {
  return getBaseURL() + "Park/CloseTo/" + lat + "/" + lng;
}

export function GetNoteURL(client: string): string {
  return getBaseURL() + "Note/" + client;
}

export function GetParkNoteURL(park: string): string {
  return getBaseURL() + "ParkNote/" + park;
}

export function GetClientURL(client: string): string {
  return getBaseURL() + "Client/" + client;
}

export function GetAllClientURL(): string {
  return getBaseURL() + "Clients/";
}

export function GetTermsAndConditionsURL(): string {
  return getBaseURL() + "TNC/";
}

export function GetClientRegistrationURL(clientName = ""): string {
  return getBaseURL() + "ClientRegistration/" + clientName;
}

export function GetClientRegistrationApproveURL(clientName: string): string {
  return getBaseURL() + "ClientRegistration/Approve/" + clientName;
}

export function GetParkURL(parkName: string = ""): string {
  return getBaseURL() + "ParkSite/" + parkName;
}

export function GetTransferURL(from: string, to: string): string {
  return getBaseURL() + "ParkSite/Transfer/" + from + "/" + to;
}

export function GetUserURL(userUid = ""): string {
  return getBaseURL() + "User/" + userUid;
}

export function GetAllUsersURL(): string {
  return getBaseURL() + "Users/";
}

export function GetParkListURL(): string {
  return getBaseURL() + "Park/";
}

export function GetParkActivateRequestURL(parkName: string): string {
  return getBaseURL() + "ParkActivateRequest/" + parkName + "/";
}

export function GetEmergencyShutdownRequestURL(): string {
  return getBaseURL() + "EmergencyShutdownRequest/";
}

export function GetTimeInParksURL(startDate: string, endDate: string): string {
  return getBaseURL() + "TimeInParksV2/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}

export function GetWonAtParkURL(startDate: string, endDate: string) {
  return getBaseURL() + "WonAtParkV2/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}

export function GetStartedGameURL(startDate: string, endDate: string) {
  return getBaseURL() + "StartedGame/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}

export function GetDateReportURL(startDate: string, endDate: string) {
  return getBaseURL() + "ReportByCouncilAndDateV2/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}

export function GetAddressURL(address: string) {
  return getBaseURL() + "latlng/" + address;
}

export function validateEmail(email: string | null) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

